import React from "react";
import { Modal } from "antd";

type Props = {
  onClose: () => void;
};

const StoreError: React.FC<Props> = ({ onClose }) => {
  const [modalOpen, setModalOpen] = React.useState(true);

  const handleModalClose = () => {
    setModalOpen(false);
    onClose();
  };

  return (
    <Modal
      open={modalOpen}
      onCancel={handleModalClose}
      footer={[ // 自定义底部按钮
        <a
          key="support"
          className="button button--primary"
          href="https://lv.aliving.stream/support.html"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: "1.1em" }}
        >
          View Support Guide
        </a>
      ]}
      width={600}
      style={{ top: 20 }}
    >
      <div className="Settings">
        <h2 style={{ margin: 0 }}>Storage Error</h2>
        <p style={{ fontSize: "1.25em" }}>
          LuminaVerse is unable to load or save settings. This is most commonly
          caused by running in private browsing mode; but low disk space or a
          corrupt browser profile can also be the problem.
        </p>
        <p>
          If you have settings saved with LuminaVerse, it might be a temporary
          issue. Try restarting your browser and checking if your settings
          return.
        </p>
        <p>
          If they do not return, the{" "}
          <a href="https://lv.aliving.stream/support.html">support guide</a> covers the
          common causes and how to resolve them. Otherwise, contact{" "}
          <a href="mailto:truemylife@gmail.com">truemylife@gmail.com</a> if you are
          still unable to solve the issue.
        </p>
      </div>
    </Modal>
  );
};

export default StoreError;